import { SimpleApp } from '../../libs/apps';
import { AppsResponse, AppsData } from './types';

/**
 * Takes the apps data response and transforms it into
 * the form we want to use in our React state
 *
 * @param response the response returned by calling /applications/
 */
export function createAppsData(response: AppsResponse): AppsData {
  const apps = Object.keys(response.apps);
  apps.map((appKey) => {
    const app: SimpleApp = response.apps[appKey];
    if (!app.isCustomProgram) {
      app.name = app.name
        .slice(3)
        .match(/[A-Z]+[^A-Z]*|[^A-Z]+/g)
        .join(' ');
    }
  });
  return {
    apps: response.apps,
    tags: response.tags
  };
}
